/* eslint-disable @typescript-eslint/no-deprecated */
import * as React from 'react';
import styled from 'styled-components';
import { Breakpoint } from '../../styles';
const MOB_WIDTH = '350';
export const OtherListItem = ({ text, containerStyle, adornment }) => {
    return (React.createElement(CompanyItemContainer, { style: containerStyle },
        React.createElement(FlexBox, null,
            React.createElement("div", { style: {
                    alignSelf: 'stretch',
                    minWidth: '0.55rem',
                } }),
            React.createElement("div", { style: {
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flex: 1,
                    padding: '1rem 0',
                } },
                React.createElement(Text, null,
                    React.createElement("p", null, text)),
                adornment != null ? adornment : null))));
};
const CompanyItemContainer = styled.div `
  border-bottom: ${({ theme }) => theme.colors.grey.medium} 1px solid;
  color: ${({ theme }) => theme.colors.dark};
  cursor: ${(props) => (props.clickable ? 'pointer' : 'inherit')};
  flex: 0 0 30%;
  @media (max-width: ${Breakpoint.tablet}) {
    width: ${MOB_WIDTH} !important;
    flex: 100% !important;
  }
`;
const FlexBox = styled.div `
  display: flex;
  align-items: center;
`;
const Text = styled.div `
  margin-left: 0.5rem;
  margin-right: 5px;
  flex-grow: 1;
  font-size: 1.4rem;
`;
